'use client';

import { useState } from 'react';
import { clsx } from 'clsx';
import CarouselNavigation from './CarouselNavigation';

type DirectionType = 'prev' | 'next';

interface CarouselProps {
  children?: React.ReactNode[];
  className?: string;
}

export default function Carousel({ children, className }: CarouselProps) {
  const numberOfItems = children?.length || 0;
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(numberOfItems === 2 ? 'prev' : 'next');
  const [isSliding, setIsSliding] = useState(false);

  const transformClassName = !isSliding
    ? '-translate-x-full'
    : direction === 'prev'
      ? '-translate-x-[200%]'
      : 'translate-x-0';

  const transitionClassName = isSliding ? '' : 'transition duration-1000 ease-in';

  return (
    <div className={clsx('flex flex-col overflow-hidden', className)}>
      <div className={`flex flex-row ${transitionClassName} ${transformClassName}`}>
        {children?.map((child: React.ReactNode, index: number) => (
          <div key={`item-wrapper-${index}`} className={`shrink-0 grow basis-full`} style={{ order: getOrder(index) }}>
            {child}
          </div>
        ))}
      </div>
      <CarouselNavigation
        items={children}
        activeIndex={activeIndex}
        onPreviousItem={onPreviousItem}
        onItemClick={onItemClick}
        onNextItem={onNextItem}
      />
    </div>
  );

  function getOrder(itemIndex: number) {
    return (itemIndex - activeIndex + numberOfItems) % numberOfItems;
  }

  function onPreviousItem() {
    slide('prev', activeIndex === 0 ? numberOfItems - 1 : activeIndex - 1);
  }

  function onItemClick(index: number) {
    if (activeIndex === index) return;

    slide(index > activeIndex ? 'next' : 'prev', index);
  }

  function onNextItem() {
    slide('next', activeIndex === numberOfItems - 1 ? 0 : activeIndex + 1);
  }

  function slide(direction: DirectionType, activeIndex: number) {
    setIsSliding(true);
    setDirection(direction);
    setActiveIndex(activeIndex);

    setTimeout(() => {
      setIsSliding(false);
    }, 50);
  }
}
